
<p> Aurthor: {{quoted.userName}}Posted: {{quoted.quoteDay | date }} days ago.</p>
        
<img src="../assets/img/like.png" alt="Like-Image" id="like" (click) = 'like()' > {{quoted.like}}
        
<img src="../assets/img/dislike.png" alt="Dislike-image" id="dislike" (click)= "dislike()"> {{quoted.dislike}}
      
<img src="../assets/img/delete-bin.png" alt="delete-image" id="delete" (click)="deleteQuote(true)"> 
